import React from 'react';
import SiteHeader from './SiteHeader';
import Footer from './sections/Footer';
import Seo from './Seo';
import { businessInfo } from '../mock';
import { SITE_URL, getBreadcrumbJsonLd } from '../lib/structuredData';
import { formatLegalDate } from '../lib/legal';

// Envoltorio común de las páginas legales (/privacidad, /terminos): mismo
// header/footer que el resto del sitio, tipografía de lectura larga y el
// "última actualización" siempre visible arriba (requisito práctico: el
// usuario debe poder saber qué versión aceptó).
const LegalLayout = ({ title, seoTitle, seoDescription, path, updatedAt, intro, children }) => {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${SITE_URL}${path}#page`,
      name: seoTitle,
      url: `${SITE_URL}${path}`,
      inLanguage: 'es-EC',
      dateModified: updatedAt,
      isPartOf: { '@id': `${SITE_URL}/#website` },
    },
    getBreadcrumbJsonLd([
      { name: 'Inicio', path: '/' },
      { name: title, path },
    ]),
  ];

  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <Seo title={seoTitle} description={seoDescription} path={path} jsonLd={jsonLd} />
      <SiteHeader />

      <main className="container mx-auto px-4 md:px-6 py-10 flex-1">
        {/* mx-auto: sin esto la columna de lectura se pega al borde izquierdo y
            en pantallas anchas la pagina se ve descuadrada frente al header. */}
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-chocolate mb-2">{title}</h1>
          <p className="text-sm text-chocolate-light/80 mb-6">
            Última actualización: {formatLegalDate(updatedAt)}
          </p>
          {/* Texto justificado (con guionado automático, que el <html lang="es-EC">
              habilita): en párrafos legales largos da un bloque parejo y más
              formal. Sin hyphens-auto, justificar en español abre "ríos" de
              espacio entre palabras. */}
          {intro && <p className="text-lg text-chocolate-light leading-relaxed text-justify hyphens-auto mb-8">{intro}</p>}

          <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8 space-y-8">
            {children}
          </div>
        </div>
      </main>

      <Footer businessInfo={businessInfo} />
    </div>
  );
};

// Sección numerada reutilizable dentro de una página legal.
export const LegalSection = ({ id, heading, children }) => (
  <section id={id} className="space-y-3 scroll-mt-24">
    <h2 className="text-xl md:text-2xl font-bold text-chocolate">{heading}</h2>
    <div className="space-y-3 text-chocolate-light leading-relaxed text-justify hyphens-auto">{children}</div>
  </section>
);

export default LegalLayout;
